import { apiClient } from "./apiClient";

export interface InspecaoTempoMedioParams {
  dataInicio: string;
  dataFim: string;
  lojaId?: number;
}

export interface InspecaoTempoMedioResponse {
  data: string;
  dataInicio: string;
  dataFim: string;
  lojaId?: number | null;
  quantidadeProducoes: number;
  tempoMedioProducao: string;
  tempoMedioMontagem: string;
  tempoMedioForno: string;
  tempoMedioEntrega: string;
  tempoMedioAguardandoEntrega: string;
  tempoMedioAguardandoMontagem: string;
  tempoMedioTotalProducao: string;
  tempoMedioTotalEntrega: string;
  tempoMedioTotal: string;
}

export interface InspecaoPedidoTempoParams {
  displayId: number;
  lojaId?: number;
  dataInicio?: string;
  dataFim?: string;
}

export interface DescricaoItemPedido {
  item_original_name?: string | null;
  name?: string;
  quantidade?: number;
  borda?: string | null;
  sabores?: string[];
  observacao?: string | null;
}

export interface InspecaoPedidoTempoResponse {
  displayId: number;
  lojaId?: number | null;
  createdAt?: string | null;
  descricao?: DescricaoItemPedido[] | null;
  tempos: {
    aguardandoMontagem: string;
    montagem: string;
    forno: string;
    aguardandoEntrega: string;
    entrega: string;
    totalEtapas: string;
  };
}

export interface InspecaoSnapshotParams {
  dataInicio: string;
  dataFim: string;
  lojaId?: number | null;
}

export type InspecaoSnapshotParamsLegacy = {
  data: string;
  lojaId?: number | null;
};

export interface InspecaoSnapshotResponse {
  id: number;
  data: string;
  horario: string;
  lojaId: number | null;
  quantidadeProducoes: number;
  tempoMedioProducao: string;
  tempoMedioAguardandoEntrega: string;
  tempoMedioEmEntrega: string;
  pizzasAProduzir: number | null;
  isTotal?: boolean;
}

export const SNAPSHOT_HORARIOS_ORDER = [
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:20",
  "23:45",
] as const;

function appendInspecaoPeriod(
  searchParams: URLSearchParams,
  dataInicio: string,
  dataFim: string
): void {
  searchParams.set("dataInicio", dataInicio.trim());
  searchParams.set("dataFim", dataFim.trim());
}

export const inspecaoService = {
  async getSnapshots(
    params: InspecaoSnapshotParams | InspecaoSnapshotParamsLegacy
  ): Promise<InspecaoSnapshotResponse[]> {
    const searchParams = new URLSearchParams();
    if ("data" in params && params.data != null && params.data !== "") {
      appendInspecaoPeriod(searchParams, params.data, params.data);
    } else {
      const range = params as InspecaoSnapshotParams;
      appendInspecaoPeriod(searchParams, range.dataInicio, range.dataFim);
    }
    if (params.lojaId != null) {
      searchParams.set("lojaId", String(params.lojaId));
    }
    return apiClient.get<InspecaoSnapshotResponse[]>(
      `/inspecao/snapshots?${searchParams.toString()}`
    );
  },

  async getTempoMedio(
    params: InspecaoTempoMedioParams
  ): Promise<InspecaoTempoMedioResponse> {
    const searchParams = new URLSearchParams();
    appendInspecaoPeriod(searchParams, params.dataInicio, params.dataFim);
    if (params.lojaId != null) {
      searchParams.set("lojaId", String(params.lojaId));
    }

    return apiClient.get<InspecaoTempoMedioResponse>(
      `/inspecao/tempo-medio?${searchParams.toString()}`
    );
  },

  async getPedidoTempos(
    params: InspecaoPedidoTempoParams
  ): Promise<InspecaoPedidoTempoResponse[]> {
    const searchParams = new URLSearchParams();
    searchParams.set("displayId", String(params.displayId));
    if (params.lojaId != null) {
      searchParams.set("lojaId", String(params.lojaId));
    }
    const di = params.dataInicio?.trim();
    const df = params.dataFim?.trim();
    if (di) {
      appendInspecaoPeriod(searchParams, di, df && df.length > 0 ? df : di);
    }

    return apiClient.get<InspecaoPedidoTempoResponse[]>(
      `/inspecao/pedido-tempos?${searchParams.toString()}`
    );
  },
};
